import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { UpcommingEvent } from "components/dashboard/home/UpcommingEvent";
import { RadioBroadcast } from "components/dashboard/home/RadioBroadcast";
import DynamicBackground from "./DynamicBg";
import event1 from "../../../../../assets/images/event1.png";
import event2 from "../../../../../assets/images/event2.png";
import event3 from "../../../../../assets/images/event3.png";
import radio1 from "../../../../../assets/images/radio1.png";
import radio2 from "../../../../../assets/images/radio2.png";
import radio3 from "../../../../../assets/images/radio3.png";
import { EventServices } from "services/event";
import { CourseServices } from "services/courses";

const Home = () => {
  const roles = JSON.parse(sessionStorage.getItem("#roles") || "{}");
  const navigate = useNavigate();
  // eslint-disable-next-line no-unused-vars
  const userId = JSON.parse(sessionStorage.getItem("#userId") || "{}");
  const [endpoint, setApiEndpoint] = useState("");
  const [bgColor, setBgColor] = useState("");
  const [textColor, setTextColor] = useState("");
  const [dynamicText, setDynamicText] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [title, setTitle] = useState("");
  // eslint-disable-next-line no-unused-vars
  const [isLoading, setLoading] = useState(false);
  const [allEvent, setAllEvents] = useState([]);
  const [courses, setCourses] = useState([]);

  console.log(allEvent);

  useEffect(() => {
    if (roles) {
      if (roles === "student") {
        setBgColor("bg-primary");
        setSubtitle("Track Your Progress and Achievements");
        setTitle("Student Learning");
        setTextColor("text-[#00296B]");
        setDynamicText("text-[#00296B]");
        setApiEndpoint("/student-dashboard-endpoint");
      } else if (roles === "teacher") {
        setBgColor("bg-blueColor");
        setSubtitle("Access Comprehensive Teaching Resources");
        setTitle("Teacher Learning");
        setTextColor("text-white");
        setDynamicText("text-secondary");
        setApiEndpoint("/teacher-dashboard-endpoint");
      } else {
        setBgColor("bg-greenColor");
        setSubtitle("Access Comprehensive Guest Resources");
        setTitle("Guest Learning");
        setTextColor("text-white");
        setDynamicText("text-secondary");
        setApiEndpoint("/guest-dashboard-endpoint");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  useEffect(() => {
    getAllEvents();
  }, []);

  const getAllEvents = async () => {
    setLoading(true);
    try {
      const response = await EventServices.fetchEvents();
      // console.log("fetch event", response);
      if (response.data.status === "success") {
        const res = response.data.data.details;
        setAllEvents(res?.rows);
        setLoading(false);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const course = [
    {
      id: 1,
      img: "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
      dept: "Science",
      text: "Advanced Chemistry- Introduction to Chemistry For SS3 Students",
      instructorName: "Adebayo olawuyi",
      activityText: "Introduction to Chemistry",
      instructorRole: "Instructor",
      rate: 70,
    },
    {
      id: 2,
      img: "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
      dept: "Arts & Humanities",
      text: "Government: The Pre-Colonial Era in Nigeria",
      activityText: "Government: The Pre-Colonial Era",
      instructorName: "Adebayo olawuyi",
      instructorRole: "Instructor",
      rate: 70,
    },
    {
      id: 3,
      img: "https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg",
      dept: "Sciences",
      text: "Introduction to Further Mathematics For SS1 Students",
      activityText: "Introduction to Further Mathematics",
      instructorName: "Adebayo olawuyi",
      instructorRole: "Instructor",
      rate: 70,
    },
  ];
  useEffect(() => {
    getEnrollCourses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const token = JSON.parse(sessionStorage.getItem("token") || "{}");
  const getEnrollCourses = async () => {
    setLoading(true);
    try {
      const response = await CourseServices.getEnrolledCourse(token, userId);
      // console.log("fetch event", response);
      if (response.data.status === "success") {
        const res = response.data.data.details;
        console.log(response);
        setCourses(res?.rows);
        console.log(res?.rows);
        setLoading(false);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  console.log(courses, "courses");

  const resumeCourses = courses?.slice(0, 3);

  const upcommingEvents = [
    {
      id: 1,
      img: event1,
      name: "Nigeria's 64th Independence Day",
      time: "4.00pm",
      date: " 24.04.2024",
    },
    {
      id: 2,
      img: event2,
      name: "Junior West Africa Entrance Examination",
      time: "4.00pm",
      date: " 24.04.2024",
    },
    {
      id: 3,
      img: event3,
      name: "Annual Lagos Teacher's Day Celebration",
      time: "4.00pm",
      date: " 24.04.2024",
    },
  ];

  const upcommingEvent = allEvent.slice(0, 3);
  console.log(upcommingEvent, "upcoming");
  const broadcasts = [
    {
      id: 1,
      img: radio1,
      name: "the Beat 99.9 FM",
    },
    {
      id: 2,
      img: radio2,
      name: "Wazobai 95.1 Lagos",
    },
    {
      id: 3,
      img: radio3,
      name: "EKO 89.7 FM",
    },
  ];

  return (
    <div className="p-6 bg-gray-100 flex-1 overflow-auto w-full">
      <main className="flex md:flex-row flex-col  w-full gap-6 ">
        <div className="md:w-[75%] w-full">
          {/* first section */}
          <DynamicBackground
            bgColor={bgColor}
            title={title}
            subtitle={subtitle}
            textColor={textColor}
            dynamicText={dynamicText}
          />

          <div className="flex flex-col gap-6 ">
            <div className="flex justify-between items-center">
              <h2 className="md:text-[20px] font-semibold">Resume Learning</h2>
            </div>
            <div className="grid md:grid-cols-3 grid-cols-1 gap-6">
              {resumeCourses && resumeCourses.length > 0 ? (
                resumeCourses.map((course) => (
                  <div
                    className="bg-white p-3 rounded-md flex shadow-sm flex-col gap-2"
                    key={course.course.id}
                  >
                    <div className="rounded-lg">
                      <img
                        src={course.course.thumbnail}
                        alt="course-img"
                        className="h-[113px] w-full object-cover rounded-lg"
                      />
                    </div>
                    <button className="bg-primary w-fit px-2 py-1 text-blueColor text-[8px] font-medium rounded-md">
                      {course.course.subCategory}
                    </button>
                    <p className="font-semibold text-[14px] leading-[20px]">
                      {course.course.title}
                    </p>
                    <div className="flex w-full justify-between items-center gap-2">
                      <div className="w-[80%] bg-lightYellow h-[6px]">
                        <div className={`${bgColor} w-[70%] h-full`}></div>
                      </div>
                      <p className="text-blueColor font-bold text-[11px] leading-[16px]">
                        70%
                      </p>
                    </div>
                    <div className="flex gap-4">
                      <div>
                        <div className="w-6 h-6 rounded-full">
                          <img
                            src="https://res.cloudinary.com/dmrtylvtc/image/upload/v1718713134/ERC/seinor_jd046y.svg"
                            alt="profile"
                            className="w-full h-full object-cover rounded-full"
                          />
                        </div>
                      </div>
                      <div className="flex flex-col justify-between text-[8px]">
                        <h2 className="text-gray-500 font-semibold">
                          {course.course.tutor}
                        </h2>
                        <p>{course.instructorRole}</p>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p className="text-center col-span-full text-gray-500 font-medium">
                  You haven't enrolled for any course yet.
                </p>
              )}
            </div>
          </div>

          {/* Section 2 */}
          <div className="flex flex-col gap-6 mt-8">
            <div className="flex justify-between items-center">
              <h2 className="md:text-[18px] font-semibold text-[#202020]">
                All Activities
              </h2>
              <Link
                to="../my-courses"
                className="text-[#F6C61B] text-[12px] underline"
              >
                See All
              </Link>
            </div>
            <main className="bg-white w-full rounded-tr-lg rounded-tl-lg shadow-sm p-4 overflow-x-auto">
              <table className="w-full table-auto min-w-[600px]">
                <thead>
                  <tr className="text-[#3F3F3F] text-[10px] md:text-[12px] font-inter font-semibold">
                    <th className="text-left py-2">ACTIVITIES</th>
                    <th className="text-left py-2">COURSE PERCENTAGE</th>
                    <th className="md:w-72 py-2">
                      <div className="flex flex-wrap md:flex-nowrap items-center justify-between gap-2">
                        <p>ALL</p>
                        <p>ONGOING</p>
                        <p>COMPLETE</p>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {course?.map((items) => (
                    <tr key={items.id} className="border-t">
                      <td className="py-4">
                        <div className="flex items-center gap-2">
                          <img
                            src={items.img}
                            className="w-12 h-12 object-cover rounded"
                            alt="img"
                          />
                          <div className="flex flex-col gap-1">
                            <h2 className="font-semibold text-[12px] md:text-[14px] leading-[20px]">
                              {items.activityText}
                            </h2>
                            <p className="text-[#5F5F5F] text-[10px] md:text-[11px]">
                              {items.dept}
                            </p>
                          </div>
                        </div>
                      </td>
                      <td className="text-left py-4">
                        <div className="bg-blueColor w-fit py-1.5 px-4 rounded-md text-primary font-semibold text-[11px] md:text-[12px] leading-[18px]">
                          {items.rate}%
                        </div>
                      </td>
                      <td className="py-4">
                        <div
                          className={`${bgColor} py-2 px-4 cursor-pointer flex justify-center items-center rounded-md`}
                        >
                          <div
                            to=""
                            className={`${textColor} font-semibold text-[11px] md:text-[12px] leading-[18px]`}
                          >
                            View Course
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </main>
          </div>
        </div>

        <div className="lg:w-[25%] md:w-[40%] w-full bg-white p-6">
          <div className="flex flex-col gap-12">
            <div className="flex justify-between">
              <UpcommingEvent data={upcommingEvent} />
            </div>
            <RadioBroadcast data={broadcasts} />
          </div>
        </div>
      </main>
    </div>
  );
};

export default Home;
